import { writable } from 'svelte/store';

//this is used for gen 2 hook links. I need it to store value which will be used inside url.
const createLinkStore = () => {
	const { subscribe, set, update } = writable('');

	return {
		subscribe,
		set,
		resetLink: () => set(''),
	};
};
export const linkStore = createLinkStore();
